export var isPaginationStepHidden = function isPaginationStepHidden(_ref) {
  var slidesCount = _ref.slidesCount,
    currentSlide = _ref.currentSlide,
    slideIndex = _ref.slideIndex;
  return slidesCount > 8 && (slideIndex < currentSlide - 2 || slideIndex > currentSlide + 2);
};
//# sourceMappingURL=isPaginationStepHidden.js.map